
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"26.7","y":"14.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M19.08 24.342l4.742-17.55 1.074-.001-5.448 19.21h-.103l-.265-1.659zm-1.914-5.726l2.25 5.726L19.3 26h-.11l-2.981-7.384h.956zm-2.53.904v-.904h2.463v.904h-2.464z","fill":"currentColor"}}),_c('path',{attrs:{"fill":"currentColor","d":"M23.968 6.791h16.831v.804H23.968z"}}),_c('rect',{attrs:{"x":"6.936","y":"5.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    